// Runtime-derived API base — BUG 7 fix.
// REACT_APP_BACKEND_URL is baked into the bundle at build time and on the
// production host it can still point at the preview hostname. For any
// auth/cart (cookie-bearing) traffic the call MUST be same-origin so the
// browser sends this host's cookies: use window.location.origin.
// SSR / test fallback: the production host. NEVER *.myshopify.com and
// never the preview hostname.
export const API_BASE =
  (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin
    : 'https://loadout.co.in';
